module.exports = __webpack_public_path__ + "img/bell-icon-01.5e4762ac.svg";